import React, {PropTypes} from 'react';
import TournamentTechFeeModalContainer from './TournamentTechFeeModalContainer.jsx';
import AuthorizeContainer from 'shared/auth/AuthorizeContainer.jsx';

const FeeDetail = ({
  tournamentName,
  accountName,
  fee,
  defaultTechnologyFee,
  tournamentId
  ,onEditTournamentTechFeeClick
}) => (
  <div>    
  <div className="list-group-item-labeled">
    <div className="list-group-item-labeled-child"
      style={{width: 300}}>
      <span>{'Tournament'}</span>
      <span>{tournamentName}</span>
    </div>
    <div className="list-group-item-labeled-child"
      style={{width: 200}}>
      <span>{'Account'}</span>
      <span>{accountName}</span>
    </div>
    <div className="list-group-item-labeled-child"
      style={{width: 100}}>
      <span>{'Technology Fee'}</span>
      <span>{fee == defaultTechnologyFee ? `${fee}% (default)` : `${fee}%`}</span>
    </div>
    <AuthorizeContainer hqfinancialofficer>
    <div className="list-group-item-labeled-child"
      style={{width: 100}}>
      <span>      
         <button className="btn btn-link pull-right" 
         onClick={() =>onEditTournamentTechFeeClick(tournamentId)}>
                <i className="fa fa-pencil"/> {'Edit'}
          </button>        
          <TournamentTechFeeModalContainer />
      </span>
    </div>      
    </AuthorizeContainer>
  </div>
</div>
);

FeeDetail.propTypes = {
  tournamentName: PropTypes.string,
  accountName: PropTypes.string,
  fee: PropTypes.number,
  defaultTechnologyFee: PropTypes.number,
  tournamentId: PropTypes.string,
  onEditTournamentTechFeeClick: PropTypes.func
};

FeeDetail.defaultProps = {
};

export default FeeDetail;



// WEBPACK FOOTER //
// ./src/features/finance/fees/FeeDetail.jsx